module.exports = __webpack_public_path__ + "img/default_avatar.19e53655.png";